import Vue from 'vue'
import { createI18n } from '@esign/esign-i18n'
import zh from './lang/zh-CN'
import en from './lang/en'

import zhUI from '@esign/esign-design-web/lib/locale/lang/zh-CN'
import enUI from '@esign/esign-design-web/lib/locale/lang/en'
import EsignDesignWebLocale from '@esign/esign-design-web/lib/locale'


// 默认语言
export const DEFAULT_LOCALE = 'zh-CN'

let i18n = null
function initI18n(saasMainEdw) {
  if (i18n) {
    return
  }

  const edwZh = saasMainEdw.zhUI || zhUI
  const edwEn = saasMainEdw.enUI || enUI

  const messages = {
    'zh-CN': {
      ...zh,
      ...edwZh,
    },
    'en-US': {
      ...en,
      ...edwEn,
    },
  }

  i18n = createI18n(Vue, {
    fallbackLocale: DEFAULT_LOCALE,
    messages,
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    formatFallbackMessages: true,
  })

  // edw组件国际化共用国际化实例
  ;(saasMainEdw.EsignDesignWebLocale || EsignDesignWebLocale).i18n((key, value) => i18n.t(key, value))
}

// 国际化初始化
// eslint-disable-next-line no-underscore-dangle
initI18n(window.__SAASMAIN__ ? window.__SAASMAIN__.EsignDesignWeb : {})

/**
 * 翻译
 */
const translate = (key, ...args) => {
  if (i18n) {
    return i18n.t(key, ...args)
  }
  return key
}

const getLocale = () => {
  return i18n.locale
}


export { i18n, translate as $t, getLocale }
